import Col from "react-bootstrap/Col";
import styles from "./checklistForm.module.scss";
import getIcon, {Icon} from "../../../../../assets/Icons/IconClassNames";
import Row from "react-bootstrap/Row";
import SimpleConfirmModal from "../../../../../components/ModalComponents/SimpleConfirmModal";
import {useState} from "react";
import ClickableIconButton from "../../../../../components/ClickableIconButton/ClickableIconButton";
import {useChecklistContext} from "../ChecklistContext";
import {IDocumentModuleChecklistForm} from "../../../../../core/interfaces/document";

interface IChecklistFormActionButtons {
    index: number;
    form: IDocumentModuleChecklistForm;

}

const ChecklistFormActionButtons = ({index, form}: IChecklistFormActionButtons) => {
    const { copyForm, removeForm } = useChecklistContext();

    const [showDeleteFormModal, setShowDeleteFormModal] = useState(false);


    return <>
        <Row>
            <Col>
                <div className={styles.checklistFormContainerActionButtons}>
                    <div>
                        <ClickableIconButton disabled={false} buttonType={"CANCEL"} icon={getIcon(Icon.REMOVE)}
                                             onClick={() => setShowDeleteFormModal(true)}/>
                    </div>
                    <div className={"me-2"}>
                        <ClickableIconButton disabled={false} buttonType={"EDIT"} icon={getIcon(Icon.COPY)}
                                             onClick={() => copyForm(form)}/>
                    </div>
                </div>
            </Col>
        </Row>

        <SimpleConfirmModal
            show={showDeleteFormModal}
            header={<>Radera formulär?</>}
            text={<>Är du säker på att du vill radera formulär #{index + 1}. <br/>Detta val går inte att ångra.</>}
            onClickOKText={"Ja, Radera"}
            onClickOK={() => {
                removeForm(form)
                setShowDeleteFormModal(false)
            }}
            onClickCancelText={"Nej"}
            onClickCancel={() => setShowDeleteFormModal(false)}
        />
    </>
};

export default ChecklistFormActionButtons;